import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SECTION_LABELS } from '../../../core/constants/profile.constants';

@Component({
  selector: 'nr-toggle-switch',
  imports: [ToggleSwitchModule, FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './nr-toggle-switch.component.html',
  styleUrl: './nr-toggle-switch.component.scss',

  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NrToggleSwitchComponent),
      multi: true,
    },
  ],
})
export class NrToggleSwitchComponent {
  @Input() formControl!: FormControl; // Bind formControl to input
  @Input() label!: string;
  @Output() toggleChange = new EventEmitter<boolean>();
  YesNoLabels = SECTION_LABELS;
  toggleValue!: boolean;
  labelId: string = 'toggle-' + Math.random().toString(36).substring(2, 10);

  onToggleChange(event): void {
    // Emit the new value (if parent needs it)
    this.toggleChange.emit(event.checked);
  }
  writeValue(): void {}
  registerOnChange(): void {}
  registerOnTouched(): void {}
}
